// test1157
(1157 && 0);
